import { render, staticRenderFns } from "./WidgetToolbar.vue?vue&type=template&id=5111a05f&"
import script from "./WidgetToolbar.vue?vue&type=script&lang=js&"
export * from "./WidgetToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports